import React from 'react';
import axios from "axios";
import { Link } from "react-router-dom";
import { URL_CONSTANT, BUBBLE_LOADING, META_FACEBOOK, ARTICLE_POPUP_CONSTANT } from '../../constants/FrontEndConstant';
import { LANGUAGE_CODE, API_URL, META_TITLE_APPEND, IMAGE_BASEURL } from '../../constants/DotEnv';
import VorlagenGuideHeader from './SubPageHeaderH2';

const homeSectionUrl = {
    768: 'img/empirio_startseiten_grafiken_hintergrund01_content03.svg',
    375: 'img/empirio_startseiten_grafiken_hintergrund01_content03-375.svg',
    320: 'img/empirio_startseiten_grafiken_hintergrund01_content03-320.svg',
    'default': 'img/empirio_startseiten_grafiken_hintergrund01_content02.svg'
}
class VorlagenGuide extends React.Component {
    constructor(props) {
        super(props);
        this.setHomeSectionVar()
        this.state = {
            data: [],
            loading: 'false',
            article_title: '',
            article_text: '',
            survey_link: '',
            left_text: '',
            left_heading: '',
            right_image: '',
            required_btn: '',
            required_btn_link: '',
            required_btn_text: '',
            blue_text: '',
            selected_category: '',
            article_categories: [],
            article_items: [],
            filtered_article_items: [],
        }
    }
    setHomeSectionVar = () => {
        if (window.innerWidth <= 320) {
            this.homeSectionImageBg = "url(" + IMAGE_BASEURL + homeSectionUrl[320] + ")"
        } else if (window.innerWidth <= 375) {
            this.homeSectionImageBg = "url(" + IMAGE_BASEURL + homeSectionUrl[375] + ")"
        } else if (window.innerWidth < 768) {
            this.homeSectionImageBg = "url(" + IMAGE_BASEURL + homeSectionUrl[768] + ")"
        } else {
            this.homeSectionImageBg = "url(" + IMAGE_BASEURL + homeSectionUrl['default'] + ")"
        }
    }
    componentWillUnmount() {
        setTimeout(() => {
            window.setOgTag(META_FACEBOOK['og_title'], META_FACEBOOK['og_description'], META_FACEBOOK['og_image'], META_FACEBOOK['og_url'])
            window.removeSchema();
        }, 100)
    }
    componentDidMount() {
        this.scrollUpFunction();
        this.vorlagenGuideContent();
        setTimeout(() => { this.accordianExpand() }, 2000);
    }
    accordianExpand = () => {
        var acc = document.getElementsByClassName("acco-heading");
        var i;
        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function (event) {
                event.preventDefault();
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
    }
    scrollUpFunction = () => {
        /**for scrolling up page */
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        let count = document.querySelector('.navbar-toggler').className.indexOf("collapsed");
        if (count === -1) {
            document.querySelector('.navbar-collapse').classList.remove('show');
            document.querySelector('header').classList.remove("header_collapse");
            document.querySelector('.navbar-toggler').setAttribute("aria-expanded", false);
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.match.params['slug'] !== prevProps.match.params['slug']) {
            this.scrollUpFunction();
            this.vorlagenGuideContent();
        }
    }
    vorlagenGuideContent() {
        this.setState({ loading: 'true' })
        var headers = {
            "Content-Type": "application/json"
        }
        let data = '';
        let self = this;
        let article_title = '';
        let article_text = '';
        let survey_link = '';
        let left_text = '';
        let left_heading = '';
        let right_image = '';
        let required_btn = '';
        let required_btn_link = '';
        let required_btn_text = '';
        let blue_text = '';
        let count = 0;
        let article_items = [];
        let filtered_article_items = [];
        let article_browser_data = {};
        let article_categories = [];
        let meta_title = '';
        let meta_description = '';
        let meta_keywords = '';
        let og_title = '';
        let og_description = '';
        let og_image = '';
        let google_title = '';
        let articleSlug = this.props.match.params.slug;
        axios.get(API_URL + "/article/getArticle/" + articleSlug + "/" + LANGUAGE_CODE, { headers: headers })
            .then((response) => {
                data = response.data['success']['article'];
                article_title = data['article_name'];
                article_text = data['article_text'];
                survey_link = data['survey_link'];
                left_text = data['left_text'];
                left_heading = data['left_heading'];
                right_image = data['right_image'];
                required_btn = data['required_btn'];
                required_btn_link = data['required_btn_link'];
                required_btn_text = data['required_btn_text'];
                blue_text = data['blue_text'];
                google_title = data['google_title']
                meta_title = article_title + META_TITLE_APPEND;
                meta_description = data['metadescription'];
                meta_keywords = data['metakeyword'];
                window.setMeta({ "description": meta_description, "keywords": meta_keywords });
                og_title = article_title + META_TITLE_APPEND;
                og_description = meta_description;
                og_image = (data['right_image']) ? data['right_image'] : META_FACEBOOK['og_image'];
                window.setOgTag(og_title, og_description, og_image, window.location.href);
                window.setDocumentTitle(meta_title);
                article_browser_data = response.data.success.article_browser;
                article_categories = Object.keys(article_browser_data).map(key => key);
                Object.keys(article_browser_data).forEach(function (category) {
                    article_browser_data[category].forEach(function (key) {
                        article_items[count] = [];
                        article_items[count]['category'] = category;
                        article_items[count]['article_short_name'] = key['article_short_name'];
                        article_items[count]['slug'] = key['slug'];
                        count++;
                    });
                });
                filtered_article_items = article_items;
                self.setState({ data, loading: 'false', article_title, article_text, survey_link, left_text, left_heading, right_image, required_btn, required_btn_link, required_btn_text, blue_text, article_categories, article_items, filtered_article_items, google_title })
            })
            .catch((error) => {
                self.setState({ loading: 'false', data, article_title, article_text, survey_link, left_text, left_heading, right_image, required_btn, required_btn_link, required_btn_text, blue_text, article_categories, article_items, filtered_article_items, google_title });
            })
    }
    filterItems = (e, category) => {
        let filterElements = document.querySelectorAll('.theme-after');
        filterElements.forEach(function (elem) {
            elem.classList.remove('active');
        });
        e.target.className = 'active theme-after';
        e.preventDefault();
        if (category === "All") {
            this.setState({
                selected_category: category,
                filtered_article_items: this.state.article_items,
            });
        } else {
            this.setState({
                selected_category: category,
                filtered_article_items: this.state.article_items.filter(
                    (item) => item.category === category
                ),
            });
        }
    };
    render() {
        return (
            <main>
                {(this.state.loading === 'true') ?
                    BUBBLE_LOADING
                    : null
                }
                {/* <!-- banner text ---> */}
                <VorlagenGuideHeader data={this.state.data} title={this.state.article_title} />
                {/* <!-- banner-text-end --> */}
                {this.state.survey_link ?
                    <section class="section">
                        <div className="container">
                            <iframe
                                width="100%"
                                height="600"
                                allowFullScreen
                                src={this.state.survey_link}
                                id="atricle-iframe"
                                title="atricle-iframe"
                            >
                            </iframe>
                            <div className="text-center mt-5">
                                <Link to="/registrieren" className="btn btn-clr text-uppercase text-white font-18" title="Jetzt Umfrage erstellen">Jetzt Umfrage erstellen</Link>
                            </div>
                        </div>
                    </section>
                    : null
                }
                <section className="empirical-research pt-0 pb-0">
                    <div className="container">
                        <div className="row align-items-center justify-content-center">
                            <div className="col-12 empirical-research-h2">
                                <h2 dangerouslySetInnerHTML={{ __html: this.state.article_text }}></h2>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content-left content-left-bg-img home-section" style={{ "background": this.homeSectionImageBg, "background-repeat": "no-repeat", "background-size": "105%" }}>
                    <div className="container container-large pt-5">
                        <div className="row align-items-center sm-p-30px-b">
                            <div className="col-md-6 mt-2 mt-md-0">
                                <h2 dangerouslySetInnerHTML={{ __html: this.state.left_heading }}></h2>
                                <p dangerouslySetInnerHTML={{ __html: this.state.left_text }}></p>
                            </div>
                            <div className="col-md-6 text-center mxh-img order-class-sm">
                                <img src={this.state.right_image} alt={this.state.left_heading} width="400" height="400" />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="umfrage-in-erstllen footer-dark">
                    <div className="container">
                        <div className="row text-center justify-content-center align-items-center mb-4">
                            <div className="col-md-4">
                                <p><h3 class="umfrage-in-erstllen-h3">Kostenlos</h3></p>
                            </div>
                            <div className="col-md-4">
                                <p><h3 class="umfrage-in-erstllen-h3">Einfach</h3></p>
                            </div>
                            <div className="col-md-4">
                                <p><h3 class="umfrage-in-erstllen-h3">DSGVO-konform</h3></p>
                            </div>
                        </div>
                        <div className="text-center">
                            <Link to="/registrieren" className="btn btn-clr text-uppercase text-white font-18" title="Jetzt Umfrage erstellen">Jetzt Umfrage erstellen</Link>
                        </div>
                    </div>
                </section>
                {/* <!-- Article :: Start --> */}
                <section class="container mt-5 mb-5">
                    <div class="lock_btn_text_grey text-center mb-4">
                        <h2 class="font-weight-bold">Entdecke weitere spannende Umfrage-Vorlagen</h2>
                    </div>
                    <div class="portfolio-filter m-20px-b">
                        <ul class="filter filter-01 text-center">
                            <li class="active theme-after" onClick={(e) => this.filterItems(e, 'All')}>{ARTICLE_POPUP_CONSTANT[LANGUAGE_CODE]['all']}</li>
                            {this.state.article_categories.map((category) => (
                                <li class="theme-after" onClick={(e) => this.filterItems(e, category)}>{category}</li>
                            ))}
                        </ul>
                    </div>
                    {/* <!-- Article Filter --> */}
                    <div class="portfolio-content lightbox-gallery">
                        <ul class="portfolio-cols portfolio-cols-5 d-flex flex-wrap">
                            {
                                this.state.filtered_article_items.slice(0,10).map((item, itemIndex) => {
                                    return (
                                        <li class="portfolio-item illustration website" key={itemIndex}>
                                            <div class="portfolio-col">
                                                <a href={"/vorlagen/" + item.slug}>
                                                    <div class="portfolio-info d-flex justify-content-center align-items-center">
                                                        <div class="portfolio-info-inner">
                                                            <h6>{item.article_short_name}</h6>
                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        {
                            (this.state.filtered_article_items).length > 10 ?
                            <div class="mt-4" id="show-more-template">
                                <a class="font-18" title="Alle Vorlagen Entdecken" href={"/" + URL_CONSTANT['vorlagen']}>Alle Vorlagen Entdecken</a>
                            </div> :
                            null
                        }
                    </div>
                    {/* <!-- Article Content --> */}
                </section>
                {/* <!-- Article :: End --> */}
                <section className="analysiere theme-main">
                    <div className="container">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-md-10 col-lg-8">
                                <div className="section-title text-center">
                                    <h2 className="pb-2 text-white font-weight-bold">{this.state.blue_text}</h2>
                                    <Link to={this.state.required_btn_link} className="btn btn-clr text-uppercase text-white font-18" title={this.state.required_btn_text}>{this.state.required_btn_text}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        );
    }
}
export default VorlagenGuide;